import mapValues from "lodash.mapvalues";
import * as yup from "yup";

import { FormId } from "../../../../../components/enums";
import {
  cityValidator,
  emailValidator,
  nameSurnameValidatorRequired,
  phoneValidatorRequired,
  postalCodePolandValidator,
  radioValidator,
  streetHouseNumberValidator,
  streetValidator,
} from "../../../../../utilities/validators";

import { ComponentId } from "./enums";

const multiPersonValidator = {
  persons: yup.lazy((obj) =>
    yup.object(
      mapValues(obj, (_, key) => {
        return yup.object({
          name: nameSurnameValidatorRequired,
          surname: nameSurnameValidatorRequired,
          phone: phoneValidatorRequired(`witnessespersons${key}phone`),
          email: emailValidator,
          street: streetValidator,
          street2: streetHouseNumberValidator,
          zipCode: postalCodePolandValidator,
          city: cityValidator,
        });
      })
    )
  ),
};

export const validator = {
  [FormId.INCIDENT_WITNESSES]: yup.object({
    [ComponentId.IS_WITNESSES_DATA_AVAILABLE]: radioValidator,
    ...multiPersonValidator,
  }),
};
